import { render, staticRenderFns } from "./Arch.vue?vue&type=template&id=c677c4ae&scoped=true&"
import script from "./Arch.vue?vue&type=script&lang=js&"
export * from "./Arch.vue?vue&type=script&lang=js&"
import style0 from "./Arch.vue?vue&type=style&index=0&id=c677c4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c677c4ae",
  null
  
)

export default component.exports